import { ArrowUpRight, SlidersHorizontal } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LegacyLink } from "@/components/layout/LegacyLink";

export function LegacyDeploymentCallout() {
  const { t } = useTranslation();
  return <LegacyLink to="/create-deployment" className="group mt-5 flex w-full max-w-[51rem] flex-col items-start gap-4 rounded-2xl border border-[var(--field-border)] bg-card p-5 text-start text-foreground shadow-sm transition-[border-color,box-shadow] hover:border-[var(--field-focus)] hover:shadow-md focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-primary/30 sm:flex-row sm:items-center">
    <span className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-primary/15 text-foreground"><SlidersHorizontal className="size-5" aria-hidden /></span>
    <span className="flex min-w-0 flex-1 flex-col gap-1">
      <strong className="text-base font-semibold">{t("omnimizer.legacyCallout.title")}</strong>
      <span className="text-sm text-muted-foreground">{t("omnimizer.legacyForm")}</span>
    </span>
    <span className="inline-flex min-h-10 shrink-0 items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground">
      {t("omnimizer.legacyCallout.action")}
      <ArrowUpRight className="size-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 motion-reduce:transform-none rtl:-scale-x-100" aria-hidden />
    </span>
  </LegacyLink>;
}
